// https://www.online-utility.org/text/sort.jsp
// https://alphabetizer.flap.tv/
module.exports = [
    "300",
    "NF-4610",
    "NF-4615",
    "Afternoon Delight",
    "Royal Flush",
    "Bachy West XC",
    "Ben's",
    "Black Rock",
    "Bushwhacking",
    "Butte",
    "COD Rockstacker",
    "COD",
    "Catch & Release",
    "Crazyhorse", // Horse Ridge
    "Crooked Arm", // Horse Ridge
    "Creeper Steeper",
    "DRT",
    "Dinah Moe Humm",
    "Dry River Canyon", // Horse Ridge
    "Duodenum",
    "ELV",
    "EXT",
    "Edison Sno Park",
    "Edison-Lava",
    "Elko Point",
    "Escape from Moscow", // Horse Ridge
    "Expressway",
    "Farewell",
    "Flagline Access",
    "Flagline Tie",
    "Flagline",
    "Funner",
    "Grand Slam",
    "Has No Horse", // Horse Ridge
    "Helipad",
    "Holy Loop", // Horse Ridge
    "Horse Butte",
    "Horse Ridge",
    "KGB",
    "Kent's",
    "Kiwa Butte",
    "Larsen's",
    "Lone Wolf",
    "Lower Whoops",
    "MTB",
    "Mad Max Drive", // Horse Ridge
    "Marvin's Garden",
    "Metolius-Windigo",
    "Mrazek",
    "NF-4610",
    "NF-4615/Swede Rd",
    "Northfork",
    "Old Dirty Pirate",
    "Parkway", // Horse Ridge
    "Phil's",
    "Pinedrops",
    "Ridge Loop",
    "Roundabout",
    "S.S.T.",
    "SST",
    "Sand Canyon", // Horse Ridge
    "Sector 16",
    "Shevlin Park",
    "Skyliner",
    "Southfork",
    "Storm King",
    "Swamp Wells",
    "Swampy",
    "Swampy-Dutchman",
    "Swan Song",
    "Swede Ridge",
    "Tetherow Connector",
    "Ticket to Ride",
    "Tiddlywinks",
    "Tumalo Creek",
    "Tumalo Ridge",
    "Tumalo Tie",
    "Tyler's Traverse",
    "Tyler's Uphill",
    "Unknown",
    "Upper Whoops",
    "Upper Whoops Uphill (NF-4615)",
    "Vista Butte",
    "VooDoo Child",
    "VooDoo",
    "Waldo Lake", // Oakridge
    "Charlton Lemish Loop Trail",  // Oakridge
    "Magone Lake",
    "Madras East Hills",
    "Maston",
    "Rockbar", // Maston
    "Headgate", // Maston
    "Talon", // Maston
    "Oregon Sunshine", // Maston
    "Fat Rabbit Loop", // Maston
    "Pumice Foot", // Maston
    "Lost Dream", // Maston
    "Maston Outer Loop", // Maston
    "Big Bark", // Maston
    "Hardesty", // Oakridge
    "Lawler", // Oakridge
    "Alpine", // Oakridge
    "Tire Mountain", // Oakridge
    "Cloverpatch", // Oakridge
    "NF-4615 (Swede Ridge Rd)"
];
